import { initializeApp } from "firebase/app";
import {
  getStorage,
  ref,
  uploadBytes,
  getDownloadURL,
  getBytes,
} from "firebase/storage";
import {
  getFirestore,
  collection,
  addDoc,
  getDocs,
  doc,
  getDoc,
  query,
  where,
  setDoc,
  deleteDoc,
} from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAKQ-_z6T9m42-ifB7BJnamoeBTgeR0F0U",
  authDomain: "registro-eventos-871d1.firebaseapp.com",
  projectId: "registro-eventos-871d1",
  storageBucket: "registro-eventos-871d1.firebasestorage.app",
  messagingSenderId: "69422866135",
  appId: "1:69422866135:web:05c9f41826188645c11a92"
};
// Initialize Firebase
export const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);

export async function userExists(uid) {
  const docRef = doc(db, "users", uid);
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    //console.log("Document data:", docSnap.data());

    return docSnap.data();
  } else {
    // docSnap.data() will be undefined in this case
    // console.log("No such document!");
  }
}

export async function registerNewUser(user) {
  try {
    const docRef = collection(db, "users");
    const res = await addDoc(docRef, user);
    return res;
  } catch (error) {}
}

export async function registerNewResumen(user) {
  try {
    const docRef = collection(db, "inscripcion-congresoingenieria");
    const res = await addDoc(docRef, user);
    return res;
  } catch (error) {}
}

export async function insertNewLink(link, direction) {
  try {
    const docRef = collection(db, direction);
    const res = await addDoc(docRef, link);
    return res;
  } catch (error) {
    console.error(error);
  }
}

export async function getLinks(uid, direction) {
  try {
    const links = [];
    const collectionRef = collection(db, direction);
    const q = query(collectionRef, where("uid", "==", uid));
    const querySnapshot = await getDocs(q);

    querySnapshot.forEach((doc) => {
      const link = { ...doc.data() };
      link.docId = doc.id;
      links.push(link);
    });

    return links;
  } catch (error) {
    console.error(error);
  }
}

export async function getUser(username) {
  try {
    const users = [];
    const q = query(collection(db, "users"), where("username", "==", username));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      // doc.data() is never undefined for query doc snapshots
      //console.log(doc.id, " => ", doc.data());
      const user = { ...doc.data() };
      user.docId = doc.id;
      users.push(user);
    });

    return users;
  } catch (error) {
    console.log(error);
  }
}

export async function existUsername(uid) {
  const users = [];
  const collectionRef = collection(db, "users");
  const q = query(collectionRef, where("username", "==", uid));
  const querySnapshot = await getDocs(q);
  querySnapshot.forEach((doc) => {
    users.push(doc.data());
  });

  return users.length > 0 ? users[0].username : null;
}

export async function UpdateLink(id, link, direction) {
  try {
    const docRef = doc(db, direction, id);
    const res = await setDoc(docRef, link);
    return res;
  } catch (error) {
    console.log(error);
  }
}

export async function UpdateUser(id, user) {
  try {
    const docRef = doc(db, "users", id);
    const res = await setDoc(docRef, user);
    return res;
  } catch (error) {
    console.log(error);
  }
}

